import { VIEWPORT_WIDTH_COOKIE_NAME } from '@/utils/constants/viewport-client-hints';

const parsePositiveInt = (raw: string | undefined): number | undefined => {
    if (raw == null || raw === '') {
        return undefined;
    }
    const n = parseInt(String(raw).trim(), 10);
    return Number.isFinite(n) && n > 0 ? n : undefined;
};

const readCookieValue = (cookieStr: string | undefined, name: string): string | undefined => {
    if (!cookieStr) {
        return undefined;
    }
    const parts = cookieStr.split(';');
    for (const part of parts) {
        const trimmed = part.trim();
        if (!trimmed.startsWith(`${name}=`)) {
            continue;
        }
        const value = trimmed.slice(name.length + 1);
        try {
            return decodeURIComponent(value);
        } catch {
            return value;
        }
    }
    return undefined;
};

/**
 * Reads {@link VIEWPORT_WIDTH_COOKIE_NAME} from `document.cookie` (client only).
 * Use when SSR did not receive the cookie on the request but the browser already has it
 * (e.g. returning visit, or client-side `getInitialProps` without `req`).
 */
const getViewportWidthFromDocumentCookie = (): number | undefined => {
    if (typeof document === 'undefined') {
        return undefined;
    }
    return parsePositiveInt(readCookieValue(document.cookie, VIEWPORT_WIDTH_COOKIE_NAME));
};

export default getViewportWidthFromDocumentCookie;
